import React from "react";
import { Skeleton, Stack } from "@mui/material";
import styles from "../../styles/Loader.module.css";

export function SkeletonLoader() {
  return (
    <Stack
      spacing={1}
      sx={{
        backgroundColor: "var(--white)",
        padding: "10px 40px",
        height: "calc(100vh - 106px) !important",
        borderRadius: "5px",
      }}
    >
      <Skeleton
        variant="rounded"
        height={40}
        sx={{ marginLeft: "auto !important" }}
        width={"calc(100% - 50px)"}
      />
      <Skeleton
        variant="rounded"
        height={20}
        sx={{ marginLeft: "50px !important" }}
        width={160}
      />
      <Skeleton variant="rounded" width={210} height={15} />
      <Skeleton variant="rounded" height={60} />
      <Skeleton variant="rounded" height={300} />
    </Stack>
  );
}
export default SkeletonLoader;

export function SkeletonInfobar() {
  return (
    <Stack
      spacing={1}
      sx={{
        padding: "10px 40px",
        height: "calc(100vh - 106px) !important",
        borderRadius: "5px",
      }}
    >
      <Skeleton variant="rounded" height={80} />
      <Skeleton variant="rounded" height={80} />
    </Stack>
  );
}

export function SpreadsheetSkeletonRows({ cols = 11 }: { cols?: number }) {
  const widths = ["100%", "100%", "40%"];
  return (
    <tr style={{ verticalAlign: "top" }}>
      <td colSpan={cols} style={{ padding: "12px", verticalAlign: "top" }}>
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {widths.map((w, i) => (
            <div
              key={i}
              className={styles.shimmer}
              style={{ height: 48, borderRadius: 12, width: w }}
            />
          ))}
        </div>
      </td>
    </tr>
  );
}

export function SkeletonOneLine() {
  return (
    <Stack
      spacing={1}
      sx={{
        padding: "2px",
        height: "20",
        borderRadius: "5px",
       
      }}
    >
      <Skeleton variant="rounded" height={20} width={"90%"}/>
    </Stack>
  );
}